function getInitials(name) {
    const words = name.trim().split(' '); // Split the name by spaces
    if (words.length === 1) {
      // If there's only one word, return the first two letters
      return words[0].substring(0, 2);
    } else {
      // Otherwise, return the first letter of each word
      return words[0][0] + words[1][0];
    }
  }

  function maskEmail(email) {
    // Split the email into local part and domain
    const [localPart, domain] = email!=null?email.split('@'):[];
  
    // Mask the local part, leaving the first 3 characters visible
    const maskedLocalPart = localPart?.substring(0, 3) + '*****';
  
    // Combine the masked local part with the domain
    return email!=null?`${maskedLocalPart}@${domain}`:"";
  }

function maskPhoneNumber(phoneNumber) {
  if (!phoneNumber) return "Invalid phone number";
  const prefix = "+91";
  const number = phoneNumber.startsWith("+91")
    ? phoneNumber.replace("+91", "")
    : phoneNumber;

  if (number.length < 10) return "Invalid phone number";

  const maskedPart = "*".repeat(number.length - 4);
  const visiblePart = number.slice(-4);

  return `${prefix}${maskedPart}${visiblePart}`;
}

export {getInitials,maskEmail,maskPhoneNumber};